export default "/images/b232ac81e0221e6108961bf143613c1d.avif";